// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HomeTwoToneSvg from "@ant-design/icons-svg/es/asn/HomeTwoTone";
import AntdIcon from '../components/AntdIcon';

var HomeTwoTone = function HomeTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HomeTwoToneSvg
  }));
};

HomeTwoTone.displayName = 'HomeTwoTone';
export default React.forwardRef(HomeTwoTone);